import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initTikTokPixel, trackTikTokEvent } from '../pixel/tiktok';

export const useTikTokPixel = () => {
  const location = useLocation();
  const initializedRef = useRef(false);
  const previousPathRef = useRef('');
  useEffect(() => {
    if (!initializedRef.current && typeof window !== 'undefined') {
      initTikTokPixel();
      initializedRef.current = true;
    }
  }, []);

  useEffect(() => {
    if (
      initializedRef.current &&
      previousPathRef.current !== location.pathname &&
      window.ttq &&
      typeof window.ttq.page === 'function'
    ) {
      window.ttq.page();
      previousPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  return {
    trackEvent: trackTikTokEvent,
  };
};
